<template>
  <theme-provider :theme="theme">
    <slot></slot>
  </theme-provider>
</template>

<script>
import { ThemeProvider } from 'vue-styled-components';

export default {
  name: 'IpsTheme',
  components: {
    'theme-provider': ThemeProvider,
  },
  props: {
    theme: {
      type: Object,
      name: 'Theme',
      description: 'theme settings',
      required: false,
      default: () => {
        return {
          primary: '#f66a0a',
          secondary: '#172b4d',
          tertiary: '#42526e',
          success: '#36b37e',
          info: '#0065ff',
          warning: '#ffab00',
          danger: '#ff5630',
          default: '#c1c7d0',
          light: '#97a0af',
          dark: '#172b4d',
        };
      },
    },
  },
};
</script>
